/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Case_Payment_ReceivedInputs */

const vi_station_voice_case_payment_received = /** @type {(inputs: Station_Voice_Case_Payment_ReceivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã nhận thanh toán`)
};

/**

* @param {Station_Voice_Case_Payment_ReceivedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_case_payment_received = /** @type {((inputs?: Station_Voice_Case_Payment_ReceivedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Case_Payment_ReceivedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_case_payment_received(inputs)
});